
export enum RequireScrappingFilter {
  requireScrapping= 'requireScrapping',
  doNotRequireScrapping= 'doNotRequireScrapping',

}